import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import { PromptsLayout } from '../../prompts-layout'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { apiClient } from 'pobble-components/dist/api'
import Spinner from 'pobble-components/dist/spinner'

export const Copy = injectSheet({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff'
  }
})(({ classes }) => {
  const history = useHistory()
  const { copyId } = useParams()

  useEffect(
    () => {
      apiClient
        .post(`/v3/presentations/${copyId}/create_presentation_copy`)
        .then(res => {
          history.replace(`/lesson/${res.data.presentation.id}`)
        })
    },
    [copyId, history]
  )

  return (
    <PromptsLayout>
      <div className={classNames(classes.container, 'h-screen-header')}>
        <Spinner />
      </div>
    </PromptsLayout>
  )
})
